/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_Title_LeadInputs */

const en_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private lessons,`)
};

const es_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecciones privadas,`)
};

const de_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatunterricht,`)
};

const zh_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私人课程，`)
};

const ar_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دروس خاصة،`)
};

const fr_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cours particuliers,`)
};

const vi_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bài học riêng,`)
};

const sw_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mafunzo ya kibinafsi,`)
};

const th_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บทเรียนส่วนตัว`)
};

const bs_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatne lekcije,`)
};

const ja_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライベートレッスン、`)
};

const ko_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`당신을 중심으로 설계된`)
};

const pt_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aulas particulares,`)
};

const it_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lezioni private,`)
};

const sv_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privata lektioner,`)
};

const nl_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privélessen,`)
};

const da_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatundervisning,`)
};

const nb_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatundervisning,`)
};

const fi_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yksityistunteja,`)
};

const pl_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekcje prywatne,`)
};

const ru_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Частные уроки,`)
};

const tr_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özel dersler,`)
};

const hi_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निजी पाठ,`)
};

const id_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran pribadi,`)
};

const ms_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran persendirian,`)
};

const cs_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soukromé lekce,`)
};

const el_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ιδιαίτερα μαθήματα,`)
};

const he_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיעורים פרטיים,`)
};

const af_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privaatlesse,`)
};

const hu_lessons_title_lead = /** @type {(inputs: Lessons_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magánórák,`)
};

/**
* | output |
* | --- |
* | "Private lessons," |
*
* @param {Lessons_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_title_lead = /** @type {((inputs?: Lessons_Title_LeadInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Title_LeadInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_title_lead(inputs)
	if (locale === "de") return de_lessons_title_lead(inputs)
	if (locale === "zh") return zh_lessons_title_lead(inputs)
	if (locale === "ar") return ar_lessons_title_lead(inputs)
	if (locale === "fr") return fr_lessons_title_lead(inputs)
	if (locale === "vi") return vi_lessons_title_lead(inputs)
	if (locale === "sw") return sw_lessons_title_lead(inputs)
	if (locale === "th") return th_lessons_title_lead(inputs)
	if (locale === "bs") return bs_lessons_title_lead(inputs)
	if (locale === "ja") return ja_lessons_title_lead(inputs)
	if (locale === "ko") return ko_lessons_title_lead(inputs)
	if (locale === "pt") return pt_lessons_title_lead(inputs)
	if (locale === "it") return it_lessons_title_lead(inputs)
	if (locale === "sv") return sv_lessons_title_lead(inputs)
	if (locale === "nl") return nl_lessons_title_lead(inputs)
	if (locale === "da") return da_lessons_title_lead(inputs)
	if (locale === "nb") return nb_lessons_title_lead(inputs)
	if (locale === "fi") return fi_lessons_title_lead(inputs)
	if (locale === "pl") return pl_lessons_title_lead(inputs)
	if (locale === "ru") return ru_lessons_title_lead(inputs)
	if (locale === "tr") return tr_lessons_title_lead(inputs)
	if (locale === "hi") return hi_lessons_title_lead(inputs)
	if (locale === "id") return id_lessons_title_lead(inputs)
	if (locale === "ms") return ms_lessons_title_lead(inputs)
	if (locale === "cs") return cs_lessons_title_lead(inputs)
	if (locale === "el") return el_lessons_title_lead(inputs)
	if (locale === "he") return he_lessons_title_lead(inputs)
	if (locale === "af") return af_lessons_title_lead(inputs)
	if (locale === "hu") return hu_lessons_title_lead(inputs)
	return en_lessons_title_lead(inputs)
});